// What the club account actions need from a payment or invoice list item. Amounts are in kroner: the list schemas
// convert some amounts from øre (MoneyFormatter) and not others, so each caller converts before passing them in.
export interface ClubAccountItem {
  paymentReferenceID: string
  description: string
  paymentStatus: string
  customerName?: string
  kid?: string
  grossKroner: number
  paidKroner: number
}

export const formatKroner = (kroner: number) =>
  kroner.toLocaleString('no-NO', { style: 'currency', currency: 'NOK' })

export const toOere = (kroner: string | number) =>
  Math.round(Number(String(kroner).replace(',', '.')) * 100)

export const formatAccount = (account: string) => {
  const digits = account.replace(/\D/g, '')
  return digits.length === 11 ? `${digits.slice(0, 4)}.${digits.slice(4, 6)}.${digits.slice(6)}` : account
}

export const isUnpaid = (item: ClubAccountItem) =>
  item.paymentStatus === 'InitiatedPayment' || item.paymentStatus === 'InvoiceConfirmed'
